export default __webpack_public_path__ + "65ab8b993b22b81fdc982afd449ae2a3.png";